import { http } from 'cdui-js';
import { userState } from '../stores/user';

export const verifyCertNoTwoElement = (data) => {
  return http.post(`/idAuth/verifyCertNoTwoElement`, data) as any;
};

// 保存用户基本信息
export const saveUserInfo = (data) => {
  return http.post(`/user/account/base/save`, data) as any;
};

export type VerifyOpenProfileFingerprintResult = {
  valid: boolean;
  certBizNo?: string;
  resId?: string;
  /** false：身份证校验未通过，需回身份证上传页重传 */
  idCardPassed?: boolean;
  /** false：银行卡校验未通过，需回银行卡上传页重传 */
  bankCardPassed?: boolean;
};

/** 比对开户资料指纹：身份证/银联未变更时可跳过 CA 人脸，走短流程 */
export const verifyOpenProfileFingerprint = async () => {
  const result = (await http.get(`/user/account/base/verifyOpenProfileFingerprint`)) as any;
  return (result?.data ?? result) as VerifyOpenProfileFingerprintResult;
};

// 保存职业信息
export const saveCareer = (data) => {
  return http.post(`/user/account/career/save`, data) as any;
};

// 保存电子服务
export const saveApply = (data) => {
  return http.post(`/user/account/apply/save`, data) as any;
};

// 创建新开单申请
export const createNewApply = (data) => {
  return http.post(`/user/account/account/create`, data) as any;
};

// 保存账户
export const saveAccount = (data) => {
  return http.post(`/user/account/account/create`, data);
};

// 绑定银行卡
export const bingBankAcc = (data) => {
  return http.post(`/user/account/bank/bind`, data);
};

/** 开户银行下拉：/2go/market/banks */
export const fetchOpenAccountMarketBanks = () => {
  return http.get(`/2go/market/banks?limit=100&offset=0`);
};

// 提交申请（options 可传 X-No-Toast 等，由调用方自行处理提示）
export const submitApply = (data, options?: RequestInit) => {
  return http.post(`/user/account/apply/submit`, data, options);
};

/** 确认签署后生成签名 PDF，成功后再进入手写签名页 */
export const signPdf = (data: { id: string | number }) => {
  return http.post(`/user/account/apply/signPdf`, data);
};

// 获取信息
export const fetchAllInfos = async (applyType?: string) => {
  let url = `/user/account/apply/getByUserId`;
  if (applyType) {
    url = url + `?applyType=${applyType}`;
  }
  const res = http.get(url) as any;
  return res;
};

// 实体认证（按需加载阿里云 jsvm，勿在 index.html 全局引入）
export const initFaceVerify = async ({ certName, certNo, callbackUrl }) => {
  const { loadCloudAuth } = await import('../lib/loadCloudAuth');
  await loadCloudAuth();
  const MetaInfo = window.getMetaInfo?.() as (Record<string, unknown> & { guardToken?: string }) | undefined;
  if (!MetaInfo) {
    throw new Error('cloudauth getMetaInfo unavailable');
  }
  MetaInfo.guardToken = '';

  return http.post(`/idAuth/initFaceVerify`, {
    metaInfo: JSON.stringify(MetaInfo),
    certName,
    certNo,
    callbackUrl,
  });
};

//
export const createW8ben = (data) => {
  return http.post(`/user/account/tax/W-8BEN`, data);
};

// 四要素认证
export const fourFactorVerify = async (data: {
  idCardName: string;
  idCardNumber: string;
  unionpayCardnumber: string;
  phoneNumber: string;
}) => {
  const formData = new FormData();
  formData.append('idcard_name', data.idCardName);
  formData.append('idcard_number', data.idCardNumber);
  formData.append('unionpay_cardnumber', data.unionpayCardnumber);
  formData.append('phone_number', data.phoneNumber);

  const result = (await http.send(`/api/v1/idAuth/fourFactorVerify`, {
    credentials: 'include',
    body: formData,
    method: 'POST',
  })) as any;

  return result;
};

// 活体认证
export const livenessVerify = async (idCardName: string, video: File, busId) => {
  const formData = new FormData();
  formData.append('return_image ', '1');
  formData.append('idcard_name', idCardName);
  formData.append('video', video);
  formData.append('busId', busId);

  const result = (await http.send(`/api/v1/idAuth/livenessVerify`, {
    credentials: 'include',
    body: formData,
    method: 'POST',
  })) as any;

  return result;
};

// 获取主题接口，传入身份证号+姓名 返回certDN
export const themeAcquire = async (idNo, idCardName) => {
  const formData = new FormData();
  formData.append('idNo ', idNo);
  formData.append('userName ', idCardName);

  const result = (await http.send(`/api/v1/idAuth/themeAcquire`, {
    credentials: 'include',
    body: formData,
    method: 'POST',
  })) as any;

  return result;
};

// 申请证书
export const certificateApply = async (
  certDn,
  certP10,
  livingOrderNo,
  fourFactorNo,
  busId,
  videoCallbackBusUrl?: string,
) => {
  const formData = new FormData();

  formData.append('certDn ', certDn); // 证书主题
  formData.append('certP10 ', certP10); // 证书p10数据
  formData.append('livingOrderNo ', livingOrderNo); // 活体认证id
  formData.append('fourFactorNo', fourFactorNo); // 银联四要素认证id
  formData.append('busId', busId); // 流程业务id
  formData.append('videoCallbackBusUrl', videoCallbackBusUrl); // CA 人脸完成后回跳 H5

  console.log('[certificateApply] params=============>', {
    certDn,
    certP10,
    livingOrderNo,
    fourFactorNo,
    busId,
    videoCallbackBusUrl,
  });

  const result = (await http.send(`/api/v1/idAuth/certificateApply`, {
    credentials: 'include',
    body: formData,
    method: 'POST',
  })) as any;

  return result;
};

/** 人脸完成后获取证书信息（certSn 等）；bizNo/resId 须与 certificateApply 返回值一致 */
export const findCertDown = async (busId: string | number, bizNo?: string, resId?: string) => {
  const formData = new FormData();
  formData.append('busId', String(busId));

  if (bizNo) formData.append('bizNo', bizNo);
  if (resId) formData.append('resId', resId);

  console.log('[findCertDown] params', {
    busId: String(busId),
    bizNo,
    resId,
  });

  const result = (await http.send(`/api/v1/idAuth/findCertDown`, {
    credentials: 'include',
    body: formData,
    method: 'POST',
  })) as any;

  return result;
};

// 上传签名
export const signFieldFileAcquire = async (certDn, signImg, certSn, busId) => {
  const formData = new FormData();

  formData.append('certDn', certDn);
  formData.append('signImg', signImg);
  formData.append('certSn', certSn);
  formData.append('busId', busId); //

  const result = (await http.send(`/api/v1/idAuth/signFieldFileAcquire`, {
    credentials: 'include',
    body: formData,
    method: 'POST',
  })) as any;

  return result;
};

// 合并
export const filingRecordCompose = async (certDn, certSn, fileID, P1SignData, busId) => {
  const formData = new FormData();

  formData.append('certDn', certDn);
  formData.append('fileID', fileID);
  formData.append('certSn', certSn);
  formData.append('P1SignData', P1SignData);
  formData.append('busId', busId);


  console.log('[filingRecordCompose] params=============>', {
    certDn,
    fileID,
    certSn,
    P1SignData,
    busId,
  });

  const result = (await http.send(`/api/v1/idAuth/filingRecordCompose`, {
    credentials: 'include',
    body: formData,
    method: 'POST',
  })) as any;

  return result;
};

/** 开户 PDF 签名贴图：将手写签名贴到源 PDF 签署位，落库为 open_account_pdf_sign_completed */
export const composeSignatureOnAttachment = async (
  busId: string | number,
  signFile: File | Blob,
  attachType = 'open_account_pdf_sign',
) => {
  const userId = String(userState.id || '').trim();
  const formData = new FormData();
  formData.append('busId', String(busId));
  // attachType 走 Header（对齐后端 @RequestHeader("attachType")），不要 append 进 body
  // iOS/WKWebView：第三参文件名 + 显式 image/png，保证 multipart part Content-Type 与 Android 一致
  const fileName =
    (signFile instanceof File && signFile.name) || 'sign.png';
  const pngBlob =
    signFile.type === 'image/png'
      ? signFile
      : new Blob([signFile], { type: 'image/png' });
  formData.append('signFile', pngBlob, fileName.endsWith('.png') ? fileName : `${fileName}.png`);

  const result = (await http.send(`/api/v1/idAuth/composeSignatureOnAttachment`, {
    credentials: 'include',
    body: formData,
    method: 'POST',
    headers: {
      attachType,
      ...(userId ? { userId } : {}),
    },
  })) as any;

  return result;
};

// 保存活体认证ID
export const livenessVerifyByCertifyId = async (certifyId, busId) => {
  const formData = new FormData();

  formData.append('certifyId', certifyId);
  formData.append('busId', busId);

  const result = (await http.send(`/api/v1/idAuth/livenessVerifyByCertifyId`, {
    credentials: 'include',
    body: formData,
    method: 'POST',
  })) as any;

  return result;
};
